export default __webpack_public_path__ + "static/media/Inactive_circle.8bac5dba.svg";